import { lazy } from 'react';

export const ManagerPage = lazy(() => import('./page-manager'));

export const CustomerPage = lazy(() => import('./page-customer'));

export const PartnerPage = lazy(() => import('./page-partner'));

export const OpenerPage = lazy(() => import('./page-opener'));


